export function calculateNumberOfPages(totalNumberOfResults: number, numberOfResultsPerPage: number): number {
    // tslint:disable-next-line: no-bitwise
    return ((totalNumberOfResults + numberOfResultsPerPage - 1) / numberOfResultsPerPage) | 0;
}
